import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { createAppRoute } from '../../helpers/routeHelpers';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { antGrey } from '../styles/globalStyles';
import Button from 'antd/lib/button';
import Flex from 'antd/lib/flex';
import { useNavigationContext } from '../../utils/hooks/useNavigationContext';

export const NavigationToolbar = () => {
    const location = useLocation();
    const history = useHistory();

    const { orgIdParam, appIdParam, isBackArrowRoute, isReleaseRoute, isAppSettingsRoute, isReleaseCalendarRoute } =
        useNavigationContext();

    const lastReleaseRouteRef = React.useRef<string | null>(null);
    const cameFromReleaseRef = React.useRef<boolean>(false);

    React.useEffect(() => {
        if (isReleaseRoute) {
            lastReleaseRouteRef.current = location.pathname;
            cameFromReleaseRef.current = false;
        } else if (isAppSettingsRoute || isReleaseCalendarRoute) {
            if (lastReleaseRouteRef.current) {
                cameFromReleaseRef.current = true;
            }
        } else {
            lastReleaseRouteRef.current = null;
            cameFromReleaseRef.current = false;
        }
    }, [location.pathname, isReleaseRoute, isAppSettingsRoute, isReleaseCalendarRoute]);

    const getBackDestination = (): string | null => {
        if (!orgIdParam || !appIdParam) {
            return null;
        }

        const appHomeRoute = createAppRoute(orgIdParam, appIdParam);

        if (isReleaseRoute) {
            return appHomeRoute;
        }

        if (isAppSettingsRoute || isReleaseCalendarRoute) {
            if (cameFromReleaseRef.current && lastReleaseRouteRef.current) {
                return lastReleaseRouteRef.current;
            }
            return appHomeRoute;
        }

        return appHomeRoute;
    };

    const goBack = () => {
        const destination = getBackDestination();
        if (destination) {
            history.push(destination);
        }
    };

    const shouldShowBackArrow = isBackArrowRoute && orgIdParam && appIdParam;

    if (!shouldShowBackArrow) {
        return null;
    }

    return (
        <Flex align="center" style={{ padding: '8px 8px 0px 8px' }}>
            <Button
                type="link"
                icon={<ArrowLeftOutlined style={{ color: antGrey.grey1, fontSize: 24 }} />}
                onClick={goBack}
            />
        </Flex>
    );
};
